import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { classes, images } from '../data/mock';
import { Clock, Users, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const ClassesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="classes" className="py-24 bg-[#f7f5f2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-[#8B1C1C] font-semibold text-sm uppercase tracking-wider mb-4">
            {t('Our Programs', 'Program Kami')}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1e1919] mb-6">
            {t(
              'Ballet Classes for Every Age',
              'Kelas Balet untuk Setiap Usia'
            )}
          </h2>
          <p className="text-[#736c64] text-lg">
            {t(
              'Age-appropriate programs designed to nurture young dancers from their first steps.',
              'Program sesuai usia yang dirancang untuk membina penari muda dari langkah pertama mereka.'
            )}
          </p>
        </div>

        {/* Classes Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {classes.map((classItem, index) => (
            <div
              key={classItem.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={classItem.image}
                  alt={t(classItem.titleEn, classItem.titleId)}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1e1919]/60 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <span className="inline-block bg-[#8B1C1C] text-white text-sm font-semibold px-3 py-1 rounded-full">
                    {t(`Ages ${classItem.ageRange}`, `Usia ${classItem.ageRange}`)}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#1e1919] mb-3">
                  {t(classItem.titleEn, classItem.titleId)}
                </h3>
                <p className="text-[#736c64] mb-6 leading-relaxed">
                  {t(classItem.descriptionEn, classItem.descriptionId)}
                </p>
                <Button
                  variant="outline"
                  className="w-full border-[#8B1C1C] text-[#8B1C1C] hover:bg-[#8B1C1C] hover:text-white transition-colors rounded-full"
                  onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                >
                  {t('Inquire Now', 'Tanyakan Sekarang')}
                  <ChevronRight className="w-4 h-4 ml-2" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Price Notice */}
        <div className="text-center mt-12">
          <p className="text-[#736c64] italic">
            {t(
              '* Prices available upon request. Contact us for detailed information.',
              '* Harga tersedia berdasarkan permintaan. Hubungi kami untuk informasi detail.'
            )}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ClassesSection;
